var _path, _rect, _rect2, _rect3, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEntertainment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 60,
    viewBox: "0 0 53 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 19H0L4.40806 55.5979C4.71062 58.1099 6.84201 60 9.37218 60H31.947C34.5456 60 36.711 58.0095 36.9294 55.4201L40 19Z",
    fill: "#EC433A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 19,
    width: 4,
    height: 41,
    fill: "#FFFEFE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 19,
    width: 4,
    height: 41,
    fill: "#FFFEFE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 19,
    width: 4,
    height: 41,
    fill: "#FFFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27379 13.9063C-0.348497 14.3138 -0.247878 17.4719 0.255217 19H40C40 16.555 37.9876 15.9438 36.9814 15.9438C36.9814 14.5855 36.3777 11.5632 33.9629 10.3407C33.5604 5.04321 29.7704 4.73758 27.9257 5.24695C27.4226 3.71883 25.2625 1.07007 20.6466 2.70002C18.4456 -2.18998 14.8558 0.662521 13.336 2.70002C11.3236 2.86981 7.39943 4.02439 7.80191 7.28439C3.27405 8.30314 2.77095 9.83126 3.27379 13.9063Z",
    fill: "#FFD26D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9996 55.5C40.6708 57.4732 44.2628 57.8917 46.1064 57.4224C46.6417 57.2861 47.2895 57.3602 47.7704 57.6319C48.1563 57.8499 48.6778 58 49.4995 58C54.4825 58 52.8234 54.9391 51.2096 53.2171C51.0746 53.073 50.9805 52.8971 50.9347 52.705C50.5207 50.9703 49.2651 48 46.9995 48C45.0267 48 44.2702 49.8019 44.0633 51.1839C43.9928 51.6553 43.6561 52.0632 43.2322 52.2814C42.3657 52.7275 41.2993 53.7023 40.9996 55.5Z",
    fill: "#FFD26D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntertainment);
export default __webpack_public_path__ + "static/media/entertainment.58aabf682f689721431e753afade795a.svg";
export { ForwardRef as ReactComponent };